import React from 'react';

export default props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><defs><clipPath id="b"><rect width="30" height="30"/></clipPath></defs><g id="a" clipPath="url(#b)"><g transform="translate(3 5.001)" fill="none"><path d="M12,0,24,20.308H0Z" stroke="none"/><path d="M 12 2.16224479675293 L 1.927692413330078 19.20769500732422 L 22.07230758666992 19.20769500732422 L 12 2.16224479675293 M 12 -3.814697265625e-06 L 24 20.30769538879395 L 0 20.30769538879395 L 12 -3.814697265625e-06 Z" stroke="none" fill="#1f1f1f"/></g></g></svg>
    );
}